module.exports = __webpack_public_path__ + "img/detail_img4.ed0e3f6a.jpg";